import React from 'react';
import clsx from 'clsx';
import {
  Element,
  FontType,
  Color,
  Typography
} from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import styles from './__styles__/index.scss?modules';

const FrontWithLargeLogo = ({
  header,
  logo,
  logoAlt,
  tag,
  bottomLabel,
  frontDisclaimer
}) => {
  return (
    <Element
      className={clsx(styles.contentContainer, styles.front, styles.largeLogo)}
    >
      <Typography
        Component="h3"
        $size="15px"
        $lineHeight="22px"
        $family={FontType.HelveticaBold}
        theme={{ color: Color.DeepBlue, marginBottom: 5 }}
        className={styles.header}
      >
        {tag && (
          <Typography
            Component="span"
            className={styles.tag}
            $size="10px"
            $lineHeight="120%"
            $family={FontType.BentonBold}
            theme={{ color: Color.White }}
          >
            {tag}
          </Typography>
        )}
        <Sanitizer safelySetInnerHTML={header} />
      </Typography>
      <Element className={styles.logoContainer}>
        <Element
          Component="img"
          src={logo}
          className={styles.frontLogo}
          alt={logoAlt}
        />
      </Element>
      {bottomLabel && (
        <Typography
          className={styles.bottomLabel}
          Component="div"
          $size="15px"
          $lineHeight="120%"
          $family={FontType.HelveticaRegular}
          theme={{
            color: Color.Gray05
          }}
        >
          {bottomLabel}
          {frontDisclaimer && (
            <span className={styles.frontDisclaimer}>{frontDisclaimer}</span>
          )}
        </Typography>
      )}
    </Element>
  );
};

export default React.memo(FrontWithLargeLogo);
